exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dl-js": () => import("./../../../src/pages/dl.js" /* webpackChunkName: "component---src-pages-dl-js" */),
  "component---src-pages-full-js": () => import("./../../../src/pages/full.js" /* webpackChunkName: "component---src-pages-full-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mp-3-js": () => import("./../../../src/pages/mp3.js" /* webpackChunkName: "component---src-pages-mp-3-js" */),
  "component---src-pages-wav-js": () => import("./../../../src/pages/wav.js" /* webpackChunkName: "component---src-pages-wav-js" */)
}

